export interface Field {
  id: string;
  organizationId: string;
  customerId?: string;  // Reference to customer who owns this field
  name: string;
  acreage: number;
  cropType: string;
  latitude: number | null;
  longitude: number | null;
  address?: string;
  city?: string;
  state?: string;
  notes?: string;
  boundaryKml?: string;
  boundaryGeojson?: any;
  agremoFieldId?: string;
  hasBoundary?: boolean;  // Returned by list endpoint for status indicators
  createdAt: string;
  updatedAt: string;
}

export interface CreateFieldDto {
  name: string;
  acreage: number;
  cropType: string;
  customerId?: string;
  latitude?: number | null;
  longitude?: number | null;
  address?: string;
  city?: string;
  state?: string;
  notes?: string;
  boundaryGeojson?: any;
  boundaryKml?: string;
}

export interface UpdateFieldDto extends Partial<CreateFieldDto> {}
